import styled from "styled-components";
import { Table, Modal } from "semantic-ui-react";

export const SemanticTable = styled(Table)`
  th {
    font-size: 14 !important;
    font-family: sans-serif !important;
  }

  tr {
    font-size: 14;
    font-family: sans-serif;
    text-align: left;
    :hover {
      background: rgba(34, 36, 38, 0.1);
    }
  }

  td {
    width: min-content !important;
  }

  tfoot {
    a {
      color: #000000 !important;

      i {
        color: #000000 !important;
      }
    }
  }
`;

export const Select = styled.select`
  max-width: 140px !important;
  width: min-content !important;
  height: min-content !important;
  /* margin:0;
  padding: .67857143em 1em;
  outline:0;
  background:#FFFFFF;
  color:rgba(0,0,0,.87);
  font-size:13px;
  font-family:sans-serif;
  font-weight:400;
  border:1px solid rgba(34,36,38,.15);
  border-radius:4px;
  -webkit-appearance:none;
  box-shadow: 0 0 0 0 transparent inset;
  transition: color .1s ease,border-color .1s ease; */
`;

export const FieldContainer = styled.div`
  display: flex;
  flex-direction: column;

  > input {
    padding: 1rem;
  }
`;

export const ModalContentContainer = styled(Modal.Content)`
  display: flex;
  flex-direction: column;

  & > * {
    margin-bottom: 24px;
  }
`;
